import { render } from "./FechaVence.vue?vue&type=template&id=7d48ee6d&scoped=true"
import script from "./FechaVence.vue?vue&type=script&lang=js"
export * from "./FechaVence.vue?vue&type=script&lang=js"

import "./FechaVence.vue?vue&type=style&index=0&id=7d48ee6d&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d48ee6d"]])

export default __exports__